export const TAG_FILTERS = [
  { label: "Family", color: "blue" },
  { label: "Community", color: "blue" },
  { label: "Health", color: "blue" },
  { label: "Economic Issues", color: "blue" },
  { label: "Politics", color: "blue" },
  { label: "Religion", color: "blue" },
];

export const DEMOGRAPHIC_FILTERS = {
  age_group: [
    { value: "18-24", label: "18-24" },
    { value: "25-34", label: "25-34" },
    { value: "35-44", label: "35-44" },
    { value: "45-64", label: "45-64" },
    { value: "65-84", label: "65-84" },
    { value: "85_plus", label: "85+" },
  ],
  gender: [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" }
  ],
  education: [
    { value: "bachelors", label: "Bachelor's Degree" },
    { value: "graduate", label: "Graduate Degree" },
    { value: "some_college", label: "Some College/Associate's" },
    { value: "high_school", label: "High School Graduate" },
    { value: "up_to_high_school", label: "Up to High School" }
  ],
  income: [
    { value: "100k_plus", label: "Over $100,000" },
    { value: "50k_to_100k", label: "$50,000 to $100,000" },
    { value: "less_than_50k", label: "Less than $50,000" }
  ]
};
